//开发环境
//export const API_ROOT = "http://172.16.0.126:8001"
//测试环境
//export const API_ROOT = "http://172.16.0.162:8001"
//演示环境
//export const API_ROOT = "http://139.219.96.206:8001"


//开发环境
let API_ROOT = "http://172.16.0.127:8001"
let EXE_ROOT = 'http://172.16.0.163:7000'

let setIp = function() {
    API_ROOT = localStorage.getItem('IP')
    EXE_ROOT = localStorage.getItem('exeIp')
}

export { API_ROOT, EXE_ROOT, setIp }


// WEBPACK FOOTER //
// ./src/config/config.pro.js